const SessionKey = {
  TOKEN: 'Token',
  USER: 'User',
  EXPIRES: 'Expires',
  IMPERSONATED_BY: 'ImpersonatedBy',
  IS_AUTH0: 'IsAuth0',
};

export const getUserFromLocalStorage = () => ({
  userId: localStorage.getItem(SessionKey.USER),
  expires: localStorage.getItem(SessionKey.EXPIRES),
  token: localStorage.getItem(SessionKey.TOKEN),
  isAuth0: localStorage.getItem(SessionKey.IS_AUTH0) === 'true',
});

export const setUserInLocalStorage = ({ userId, expires, token, isAuth0 }) => {
  localStorage.setItem(SessionKey.EXPIRES, expires);
  localStorage.setItem(SessionKey.USER, userId);
  localStorage.setItem(SessionKey.TOKEN, token);
  localStorage.setItem(SessionKey.IS_AUTH0, isAuth0);
};

export const clearUserInLocalStorage = () => {
  localStorage.removeItem(SessionKey.EXPIRES);
  localStorage.removeItem(SessionKey.USER);
  localStorage.removeItem(SessionKey.TOKEN);
  localStorage.removeItem(SessionKey.IS_AUTH0);
};

export const setImpersonatedUserInLocalStorage = ({ userId, expires, token }) => {
  const user = getUserFromLocalStorage();
  setUserInLocalStorage({ userId, expires, token });
  localStorage.setItem(SessionKey.IMPERSONATED_BY, JSON.stringify(user));
};

export const restoreUserImpersonatorInLocalStorage = () => {
  try {
    const token = JSON.parse(localStorage.getItem(SessionKey.IMPERSONATED_BY));
    localStorage.removeItem(SessionKey.IMPERSONATED_BY);
    setUserInLocalStorage(token);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }
};
